import React from 'react';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import GoogleReviews from './components/GoogleReviews';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen">
        <Navbar />
        <Hero />
        <GoogleReviews />
        <Services />
        <About />
        <Testimonials />
        <ContactForm />
        <Footer />
        <FloatingCTA />
      </div>
    </LanguageProvider>
  );
}

export default App;
